import { useContext, useEffect, useState } from "react";
import "./Forgotpassword.scss";
import { Form, Button } from "react-bootstrap";
import { BankUserContext } from "../../bankUserContext";
import { Link, useNavigate } from "react-router-dom";
import { Field, getFormValues, reduxForm } from "redux-form";
import { toast } from "react-toastify";
import FinSpinner from "../../commonfields/FinSpinner";
import { connect } from "react-redux";
import logoFooter from "../../images/logoFooter.svg";
import { APP_Config } from "../../utils/AppConfig";
import { AxiosResponse } from "axios";
import Logo from "../../images/NoLogo.svg";
import Service from "../../services";

const ForgotPassword = (props: any) => {
  const { LogoData,orgId } = props;
  const customerService = new Service();
  const [username, setUsername] = useState<string>("");
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [theme, setTheme] = useState("default");
  const navigate = useNavigate();

  const getIsoNameByUrl = () => {
    // customerService
    // .getIsoNameByUrl()
    // .then((res) => {
    //   const profile = res?.data?.iso;
    //   if (profile) {
    //     profile &&
    //       document.body.classList.add(
    //         `theme-${profile?.toLocaleLowerCase()}`
    //       );
    //     ChangePageTitle(profile);
    //   } else document.body.classList.add("theme-default");
    //   setTheme(profile);
    // })
    // .catch((err) => {
    //   catchError(err, true);
    //   document.body.classList.add("theme-default");
    // });
  };

  useEffect(() => {
    document.body.classList.add("forgotBG");
    getIsoNameByUrl();
    return () => {
      document.body.classList.remove("forgotBG");
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const bankUserContext = useContext(BankUserContext);
  if (bankUserContext.bankuserDetails !== null) {
    navigate(`/landing`);
  }

  const getUserNameHandler = (e: any) => {
    setUsername(e.target.value);
  };

  const submitHandler = (values: any) => {
    const final = values?.userName.trim();
    if (final.length > 0) {
      setLoader(true);
      const data = {
        screen: "LoginPage",
        sections: "ForgotPassword",
        username: values.userName,
        isJsonReturnObject: false,
      };
      customerService
        .forgotPassword(data)
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            setLoader(false);
            setSuccess(true);
            props.initialize({
              userName: "",
            });
          } else {
            setLoader(false);
            // toast.error(
            //   <>
            //     <div className="fileErrorMessage">Something went wrong..</div>
            //   </>
            // );
          }
        })
        .catch((error: any) => {
          if (error.response.data) {
            setTimeout(() => {
              setLoader(false);
                setSuccess(true);
              }, 1000);
          }
        });
    } else {
      setLoader(false);
      toast.error("Please enter valid username");
    }
  };
  const loginbtn = () => {
    //eslint-disable-next-line max-len
    return (window.location.href = `/api/authorization/authorize?clientId=${APP_Config().REACT_APP_CLIENT_ID}`);
  };

  return (
    <div className="vHeight">
      {success ? (
        <div className=" userResetScreens">
          <div className="flex-1">
            <img
              className="mainLogo"
              src={
                LogoData.find((item: any) => item.iconkey === "headerIcon")
                  ?.logopath || Logo
              }
              alt="logo"
            />
          </div>
          <div className="form-signinSuccessFGLinkUsername">
            <div className="smallLogo">
              <img
                //className="mainLogo"
                src={
                  LogoData.find((item: any) => item.iconkey === "loginIcon")
                    ?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <h2 className="form-signin-heading">Forgot Password</h2>
            <div className="link-msg">
              A recovery link has been sent to the email associated with your account
            </div>
            {/* <div className="form-signin-heading2">
              Click on the link in the email to reset your password.
            </div> */}
          </div>
          <p className="d-flex footerLogo">
          {LogoData.find((item: any) => item.iconkey === "poweredBy")?.logoname}
            <img src={logoFooter} alt="footerLogo" />
          </p>
        </div>
      ) : (
        <div className="container-fluid userResetScreens">
          <div className="flex-1">
            <img
              className="mainLogo"
              src={
                LogoData.find((item: any) => item.iconkey === "headerIcon")
                  ?.logopath || Logo
              }
              alt="logo"
            />
          </div>
          <div className="form-signinFGPassword">
            <div className="backBtn">
              <span onClick={() => loginbtn()}>Back to Sign In</span>
            </div>
            <div className="smallLogo">
              <img
                //className="mainLogo"
                src={
                  LogoData.find((item: any) => item.iconkey === "loginIcon")
                    ?.logopath || Logo
                }
                alt="logo"
              />
            </div>
            <h2 className="form-signin-heading">Forgot Password</h2>
            <h6 className="form-signin-heading">
              Enter your username and we’ll send a link to reset your password{" "}
            </h6>
            <Form
              className="passwordForm"
              onSubmit={props.handleSubmit(submitHandler)}
            >
              <Form.Group controlId="formBasicEmail">
                <Form.Label className="userNameFG">Username</Form.Label>

                <div>
                  <Field
                    name="userName"
                    component="input"
                    type="text"
                    onChange={getUserNameHandler}
                    value={username}
                    className="txtUserNameFG"
                  />
                </div>
              </Form.Group>
              <p className="forgotLink">
                <Link to={`/forgotusername/${orgId}`}>
                  <span className="linkFGUserName">Forgot Username?</span>
                </Link>
              </p>
              <div className="btnWrapper">
                <Button
                  type="submit"
                  className="btn-white btn-submit3"
                  disabled={props.invalid || props.pristine || /\s/.test(username)}
                >
                  
                  Submit
                </Button>
              </div>
            </Form>
          </div>
          <p className="d-flex footerLogo">
            {LogoData.find((item: any) => item.iconkey === "poweredBy")?.logoname}
            <img src={logoFooter} alt="footerLogo" />
          </p>
        </div>
      )}
      {loader ? <FinSpinner /> : null}
    </div>
  );
};

export default connect((state: any) => {
  return {
    initialValues: {},
    formValues: getFormValues("ForgotPassword")(state),
  };
})(
  reduxForm<Record<string, unknown>, any>({
    form: "ForgotPassword",
  })(ForgotPassword)
);
